import React from "react"
import { useStepperContext } from "./stepper-context"

// =============================================================================
// Props
// =============================================================================

export type StepperHeadingProps = {
  /** Heading content, typically a title for the stepper */
  children?: React.ReactNode
}

// =============================================================================
// Component
// =============================================================================

/**
 * The stepper's title, shown above its list of steps.
 */
export function StepperHeading({ children }: StepperHeadingProps) {
  const { headingId } = useStepperContext()

  return (
    <h2
      id={headingId}
      data-slot="stepper-heading"
      className="mb-6 text-lg font-semibold text-gray-900"
    >
      {children}
    </h2>
  )
}

StepperHeading.displayName = "Stepper.Heading"
